import { render, staticRenderFns } from "./XeroSignUp.vue?vue&type=template&id=1c36768c&"
import script from "./XeroSignUp.vue?vue&type=script&lang=js&"
export * from "./XeroSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports